import React, { ReactNode } from 'react';
import { TouchableOpacity, TouchableOpacityProps } from 'react-native';
import { useTheme } from 'react-native-paper';

import { OEText } from '../../atoms';
import { flex, ph, pv } from '../../style-utils';

interface SelectInputButtonProps extends TouchableOpacityProps {
  title?: string;
  placeholder?: string;
  icon?: ReactNode;
}

export function SelectInputButton({
  title,
  placeholder,
  icon,
  ...props
}: SelectInputButtonProps) {
  const { colors } = useTheme();

  return (
    <TouchableOpacity
      style={[
        ph(14),
        pv(16),
        flex('flex-row', 'justify-content-between', 'align-items-center'),
      ]}
      hitSlop={{ top: 8, right: 12, bottom: 8, left: 12 }}
      {...props}
    >
      <OEText fontSize={16} color={title ? colors.text : colors.placeholder}>
        {title || placeholder}
      </OEText>
      {icon}
    </TouchableOpacity>
  );
}
